
import { getUserType, setUserType, setAuthToken } from '@/utils/auth'
import { localStorage, sessionStorage } from '@/utils/storage'
import { App, UserType, ExpectedActionRecaptcha } from '@/common/constant'
import commonFn, { getCurrentDomain } from '@/common/common-fn.ts'
import IDb from '@/utils/idb'
import { getEnvConfig } from '@/utils/env-variables'
import TeacherAccountAPI from '@/apis/business/account/auth-api'
import StudentAccountAPI from '@/apis/business/account/auth-student-api'

const NUMBERS_CHAR_EMAIL_DISPLAY = 2
const NUMBERS_CHAR_PHONE_DISPLAY = {
  START: 2,
  END: 3
}

/**
 * @author PVThang
 * @param {String} email email
 * @returns email hidden
 */
const hiddenEmail = (email) => {
  if (!(email?.length > 0)) {
    return ''
  }

  const indexEndHidden = email.indexOf('@')
  const numbersCharHidden = indexEndHidden - NUMBERS_CHAR_EMAIL_DISPLAY
  const strHide = numbersCharHidden > 0 ? '*'.repeat(numbersCharHidden) : ''

  return email.slice(0, NUMBERS_CHAR_EMAIL_DISPLAY) + strHide + email.slice(indexEndHidden, email.length)
}

/**
 * @author PVThang
 * @param {String} phoneNumber số điện thoại
 * @returns Số điện thoại được ẩn
 */
const hiddenPhoneNumber = (phoneNumber) => {
  if (!(phoneNumber?.length > 0)) {
    return ''
  }

  const length = phoneNumber.length
  const numbersCharHidden = length - NUMBERS_CHAR_PHONE_DISPLAY.START - NUMBERS_CHAR_PHONE_DISPLAY.END
  const strHide = numbersCharHidden > 0 ? '*'.repeat(numbersCharHidden) : ''

  return phoneNumber.slice(0, NUMBERS_CHAR_PHONE_DISPLAY.START) + strHide + phoneNumber.slice(length - NUMBERS_CHAR_PHONE_DISPLAY.END, length)
}

/**
 * @description Xóa thông tin người dùng ở storage và indexedDB
 * @author PHNam
 */
export async function clearUserData () {
  localStorage.clear()
  sessionStorage.clear()
  await IDb.clear()
}

/**
 * @author PVThang
 * @description đăng xuất
 */
const logout = async () => {
  let userType = ''
  const currentUserType = getUserType()
  let businessApi = null

  // lấy user type để vào đúng tab tại màn đăng nhập
  if (currentUserType === UserType.Student) {
    userType = 'student'
    businessApi = StudentAccountAPI
  } else {
    userType = 'teacher'
    businessApi = TeacherAccountAPI
  }

  await clearUserData()
  await businessApi?.postAsync('logout')

  commonFn.redirectToApp(App.Account, `login?type=${userType}`)
}

const getDataStudentClassroom = (res, dataSession) => {
  setUserType(UserType.Student)
  setAuthToken(res.Data.AccessToken)

  const { FullName, Phone, UserId, Image, Birthday } = res.Data.User
  const student = {
    Studentname: FullName,
    Mobile: Phone,
    Image: Image,
    Birthday: Birthday,
    StudentID: UserId
  }

  const data = { ...{ dataSession }, ...{ student } }

  return data
}

/**
 * đăng nhập vào app bằng link
 */
const redirectByLink = (redirect) => {
  const currentDomain = getCurrentDomain()
  let decodePath = decodeURIComponent(redirect)

  if (decodePath.startsWith('/') && currentDomain.endsWith('/')) {
    decodePath = decodePath.substring(1)
  }

  location.href = `${getCurrentDomain()}${decodePath}`
}

// /**
//  * @author PVThang
//  * @returns token gg recaptcha
//  */
// const getRecaptcha = async function () {
//   const me = this

//   if (me) {
//     await me.$recaptchaLoaded()
//     // Execute reCAPTCHA with action "login".
//     const token = await me.$recaptcha('login')

//     return token
//   }
// }

const addRecaptchaEnterprise = () => {
  if (!window.grecaptcha?.enterprise) {
    const recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `https://www.google.com/recaptcha/enterprise.js?render=${getEnvConfig('recaptchaSiteKey')}`)
    document.body.appendChild(recaptchaScript)
  }
}

/**
 * @author PVThang
 * @returns token gg recaptcha enterprise
 */
const getRecaptchaEnterprise = async () => {
  const recaptchaEnterprise = window.grecaptcha?.enterprise

  return new Promise((resolve, reject) => {
    recaptchaEnterprise?.ready(function () {
      recaptchaEnterprise?.execute(getEnvConfig('recaptchaSiteKey'), { action: ExpectedActionRecaptcha.Login })
        .then(token => {
          resolve(token)
        })
    })
  })
}

export { hiddenEmail }
export { hiddenPhoneNumber }
export { logout }
export { getDataStudentClassroom }
export { redirectByLink }
export { getRecaptchaEnterprise, addRecaptchaEnterprise }
